// extracted by mini-css-extract-plugin
export default {"header":"CancellationReason--header--dd65f6","button":"CancellationReason--button--c2bd6a"};